export default "__VITE_ASSET__DRt3Gsgo__"